enum FeedFilter {
  ALL = 'ALL',
  ORIGINAL = 'ORIGINAL',
  REPOST = 'REPOST'
}

export default FeedFilter
